import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CategoryViewComponentDef } from '@df/catalog-ui/category/view/category-view.component.def';
import { LocalCategory } from '../category.decorator';
import { ICategoryDataV3 } from '@df/catalog/category/category';

@Component({
    selector: 'category-view',
    template: '<category-view-layout [variant]="model!.lpLayoutVariant" ></category-view-layout>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryViewComponent extends CategoryViewComponentDef<LocalCategory<ICategoryDataV3>> {}
